<template>
  <div class="file-viewer-zip-wrapper">
    <p class="tips font-18">
      该{{ postfix }}文件无法解析预览<br />
      <temaplate v-if="singleDownloadable">请下载查看</temaplate>
    </p>
    <button
      v-if="singleDownloadable"
      class="download-btn"
      @click="$emit('download')"
    >
      <i class="iconfont icon-xiazai2"></i>
      <div class="tooltip">下载资料</div>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    postfix: {
      type: String,
      default: ''
    },
    singleDownloadable: Boolean
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-zip-wrapper {
  height: 100%;
  background: url('~@/assets/img/common/site-bg-zip.png') no-repeat center/100%
    100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .tips {
    text-align: center;
  }
  .download-btn {
    width: 40px;
    height: 40px;
    background-color: rgba(54, 54, 54, 0.85);
    color: #ffffff;
    border: none;
    outline: none;
    float: left;
    margin-right: 20px;
    border-radius: 0;
    cursor: pointer;
    position: absolute;
    right: 24px;
    bottom: 12px;
    i {
      font-size: 22px;
    }
    &:hover {
      .tooltip {
        display: block;
      }
    }
    .tooltip {
      position: absolute;
      font-size: 12px;
      white-space: nowrap;
      background-color: #363636;
      top: 0;
      left: 50%;
      width: 72px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      margin: -30px 0 0 -36px;
      border-radius: 3px;
      display: none;
    }
  }
}
</style>
